module.exports = __webpack_public_path__ + "img/102.2.f5cd42fc.png";